export const PAGES_MENU = [
  {
    path: 'dashboard',
    data: {
      menu: {
        title: 'general.menu.dashboard',
        icon: 'ion-home',
        selected: false,
        expanded: false,
        order: 400,
      }
    }
  },
  {
    path: 'funds',
    data: {
      menu: {
        title: 'general.menu.funds',
        icon: 'ion-social-bitcoin',
        selected: false,
        expanded: false,
        order: 0,
      }
    },
    children: [
      {
        path: 'vote-heads',
        data: {
          menu: {
            title: 'general.menu.vote_heads',
            selected: false,
            expanded: false,
            order: 0,
          }
        }
      },
      {
        path: 'annual-breakdown',
        data: {
          menu: {
            title: 'general.menu.annual_breakdown',
            selected: false,
            expanded: false,
            order: 0,
          }
        }
      },
      {
        path: 'fund-accounts',
        data: {
          menu: {
            title: 'general.menu.fund_accounts',
            selected: false,
            expanded: false,
            order: 0,
          }
        }
      }
    ]
  },
  {
    path: 'reported-cases',
    data: {
      menu: {
        title: 'general.menu.reported_cases',
        icon: 'ion-chatbubbles',
        selected: false,
        expanded: false,
        order: 400,
      }
    }
  },
  {
    path: 'institutions',
    data: {
      menu: {
        title: 'general.menu.institutions',
        icon: 'ion-android-apps',
        selected: false,
        expanded: false,
        order: 400,
      }
    }
  },
  {
    path: 'localization',
    data: {
      menu: {
        title: 'general.menu.localization',
        icon: 'ion-settings',
        selected: false,
        expanded: false,
        order: 0,
      }
    },
    children: [
      {
        path: 'sectors',
        data: {
          menu: {
            title: 'general.menu.sectors',
            selected: false,
            expanded: false,
            order: 0,
          }
        }
      },
      {
        path: 'sector-types',
        data: {
          menu: {
            title: 'general.menu.sector_types',
            selected: false,
            expanded: false,
            order: 0,
          }
        }
      },
      {
        path: 'sector-categories',
        data: {
          menu: {
            title: 'general.menu.sector_categories',
            selected: false,
            expanded: false,
            order: 0,
          }
        }
      },
      {
        path: 'counties',
        data: {
          menu: {
            title: 'general.menu.counties',
            selected: false,
            expanded: false,
            order: 0,
          }
        }
      },
      {
        path: 'sub-counties',
        data: {
          menu: {
            title: 'general.menu.sub_counties',
            selected: false,
            expanded: false,
            order: 0,
          }
        }
      },
      {
        path: 'constituencies',
        data: {
          menu: {
            title: 'general.menu.constituencies',
            selected: false,
            expanded: false,
            order: 0,
          }
        }
      },
      {
        path: 'wards',
        data: {
          menu: {
            title: 'general.menu.wards',
            selected: false,
            expanded: false,
            order: 0,
          }
        }
      },
      {
        path: 'population-group',
        data: {
          menu: {
            title: 'general.menu.population_group',
            selected: false,
            expanded: false,
            order: 0,
          }
        }
      },

    ]
  },
  {
    path: 'users',
    data: {
      menu: {
        title: 'general.menu.users',
        icon: 'ion-ios-people',
        selected: false,
        expanded: false,
        order: 400,
      }
    }
  },
  {
    path: 'digital-tools',
    data: {
      menu: {
        title: 'Digital Tools',
        icon: 'ion-ios-albums',
        selected: false,
        expanded: false,
        order: 400,
      }
    },
    children: [
      {
        path: 'surveys',
        data: {
          menu: {
            title: 'Surveys',
            selected: false,
            expanded: false,
            order: 0,
          }
        }
      },
      {
        path: '',
        data: {
          menu: {
            title: 'Apps',
            selected: false,
            expanded: false,
            order: 0,
          }
        }
      }
    ]
  },
  {
    path: 'projects',
    data: {
      menu: {
        title: 'Projects',
        icon: 'ion-ios-albums',
        selected: false,
        expanded: false,
        order: 400,
      }
    },

  }
];



// WEBPACK FOOTER //
// ./src/app/pages/pages.menu.ts